import { useMutation } from '@tanstack/react-query';
import { policiesService } from '../../../services/policies';
import { downloadBlob } from '../../../shared/utils/download-blob.util';

interface DownloadStarterKitParams {
  policyId: string;
  policyNo: string;
}

export function useStarterKit() {
  return useMutation({
    retry: false,
    mutationFn: async ({ policyId, policyNo }: DownloadStarterKitParams) => {
      const { blob, filename } = await policiesService.getStarterKit(policyId);
      downloadBlob(blob, filename || `kit-apolice-${policyNo}.zip`);
    },
  });
}
